import React from "react";
import { StaticImage } from "gatsby-plugin-image";

const MockupActivity = () => {
  return (
    <StaticImage
      placeholder="blurred"
      src="../../../../../images/activity_feature.png"
      alt="collar inteligente Kolyy"
    />
  );
};

export default MockupActivity;
